var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-overlay', {
    attrs: {
      "show": _vm.isLoading,
      "rounded": "lg",
      "opacity": "0.6",
      "spinner-variant": "primary"
    },
    scopedSlots: _vm._u([{
      key: "overlay",
      fn: function () {
        return [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('b-spinner', {
          attrs: {
            "small": "",
            "type": "grow",
            "variant": "secondary"
          }
        }), _c('b-spinner', {
          attrs: {
            "type": "grow",
            "variant": "dark"
          }
        }), _c('b-spinner', {
          attrs: {
            "small": "",
            "type": "grow",
            "variant": "secondary"
          }
        })], 1)];
      },
      proxy: true
    }])
  }, [_c('b-card', {
    staticClass: "mt-4",
    attrs: {
      "header": "Bulk Create",
      "header-bg-variant": "primary",
      "header-tag": "h5",
      "header-class": "font-weight-bold"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "lg": "6"
    }
  }, [_c('b-row', [_c('b-form-group', {
    staticClass: "col"
  }, [_c('b-form-file', {
    attrs: {
      "accept": ".csv",
      "placeholder": "Choose a file or drop it here...",
      "drop-placeholder": "Drop file here..."
    },
    model: {
      value: _vm.file_csv,
      callback: function ($$v) {
        _vm.file_csv = $$v;
      },
      expression: "file_csv"
    }
  }), _c('em', [_vm._v("*For the best experience, open the template file using Google Sheets")]), _c('br'), _c('b-button', {
    staticClass: "text-danger",
    attrs: {
      "variant": "link"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v(" Reset ")])], 1), _c('b-form-group', {
    staticClass: "col-md-3"
  }, [_c('b-link', {
    staticClass: "btn btn-outline",
    staticStyle: {
      "color": "#28a745",
      "border-color": "#28a745"
    },
    attrs: {
      "href": _vm.URL_STATIC.TEMPLATE_BULK_CREATE_PUBLISHER
    }
  }, [_vm._v(" Template "), _c('i', {
    staticClass: "fa fa-file-excel-o"
  })])], 1)], 1), _c('b-row')], 1), _c('b-col', {
    attrs: {
      "lg": "6"
    }
  }, _vm._l(_vm.statusUpload, function (item) {
    var _item$data;
    return _c('li', {
      key: item.item_name
    }, [item.error ? _c('span', [_vm._v(" " + _vm._s(item.data) + " " + _vm._s(item.item_name) + " - " + _vm._s(((_item$data = item.data) === null || _item$data === void 0 ? void 0 : _item$data.message) || item.message) + " ")]) : item.is_new ? _c('span', [_c('router-link', {
      attrs: {
        "target": "_blank",
        "to": {
          name: _vm.DetailItems.name,
          params: {
            id: item.data.id
          }
        }
      }
    }, [_vm._v(" " + _vm._s(item.item_name) + " ")]), _vm._v(" - success uploaded ")], 1) : _c('span', [_c('router-link', {
      attrs: {
        "target": "_blank",
        "to": {
          name: _vm.DetailItems.name,
          params: {
            id: item.data.id
          }
        }
      }
    }, [_vm._v(" " + _vm._s(item.item_name) + " ")]), _vm._v(" - item already uploaded ")], 1)]);
  }), 0)], 1)], 1), _c('b-overlay', {
    attrs: {
      "show": _vm.isValidate,
      "rounded": "lg",
      "opacity": "0.6",
      "spinner-variant": "primary"
    }
  }, [_c('b-card', {
    staticClass: "mt-4",
    attrs: {
      "header": "Review Data",
      "header-bg-variant": "primary",
      "header-tag": "h5",
      "header-class": "font-weight-bold"
    }
  }, [_c('b-row', [_c('b-col', [_c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.onUpload
    }
  }, [_vm._v(" Submit ")])], 1), _c('b-col', {
    staticClass: "text-right"
  }, [_c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.handleAdd();
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])], 1), _vm.isUpload ? _c('b-col', {
    staticClass: "p-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('b-progress', {
    attrs: {
      "value": _vm.progressBar,
      "max": _vm.maxProgressBar,
      "animated": "",
      "height": "5px"
    }
  })], 1) : _vm._e()], 1), _c('b-row', [_c('b-col', {
    staticClass: "p-3",
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('div', {
    staticClass: "table-wrap"
  }, [_vm.isBulkAuthorShow() ? _c('b-button', {
    staticClass: "badge badge-primary",
    on: {
      "click": _vm.onBulkCreateAuthor
    }
  }, [_vm._v(" create all author ")]) : _vm._e(), _c('b-table', {
    staticStyle: {
      "white-space": "unset",
      "min-height": "500px"
    },
    attrs: {
      "show-empty": "",
      "striped": "",
      "hover": "",
      "sticky-header": "600px",
      "items": _vm.bulkData,
      "fields": _vm.fields
    },
    scopedSlots: _vm._u([{
      key: "cell(name)",
      fn: function (data) {
        return [_c('div', {
          staticClass: "d-flex"
        }, [_c('span', [_vm._v(" " + _vm._s(data.index + 1) + " ")]), _c('b-form-textarea', {
          staticClass: "mx-2",
          staticStyle: {
            "width": "200px"
          },
          model: {
            value: _vm.bulkData[data.index].name,
            callback: function ($$v) {
              _vm.$set(_vm.bulkData[data.index], "name", $$v);
            },
            expression: "bulkData[data.index].name"
          }
        }), _c('i', {
          staticClass: "fa fa-trash fa-2 text text-danger",
          staticStyle: {
            "cursor": "pointer",
            "font-size": "24px"
          },
          on: {
            "click": function ($event) {
              return _vm.handleDelete(data);
            }
          }
        })], 1)];
      }
    }, {
      key: "cell(author)",
      fn: function (data) {
        return [_c('multiselect', {
          staticStyle: {
            "min-width": "200px"
          },
          attrs: {
            "label": "name",
            "track-by": "name",
            "placeholder": "Enter Author",
            "open-direction": "bottom",
            "options": _vm.authorSearchOptions,
            "loading": _vm.isAuthorSearch,
            "searchable": true,
            "close-on-select": true,
            "multiple": true
          },
          on: {
            "search-change": _vm.authorFind
          },
          model: {
            value: _vm.bulkData[data.index].author,
            callback: function ($$v) {
              _vm.$set(_vm.bulkData[data.index], "author", $$v);
            },
            expression: "bulkData[data.index].author"
          }
        }), _vm._l(_vm.authorNotFound[data.index], function (author) {
          return _c('b-row', {
            key: author
          }, [_c('b-col', {
            attrs: {
              "cols": "12"
            }
          }, [_vm._v(" " + _vm._s(author) + " "), _c('b-button', {
            staticClass: "badge badge-primary",
            on: {
              "click": function ($event) {
                return _vm.onCreateAuthor(author);
              }
            }
          }, [_vm._v("create")])], 1)], 1);
        })];
      }
    }, {
      key: "cell(languages)",
      fn: function (data) {
        return [_c('multiselect', {
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "Enter languages",
            "open-direction": "bottom",
            "label": "name",
            "track-by": "name",
            "custom-label": _vm.nameWithISO,
            "options": _vm.languagesSearchOptions,
            "searchable": true,
            "close-on-select": true,
            "multiple": true
          },
          model: {
            value: _vm.bulkData[data.index].languages,
            callback: function ($$v) {
              _vm.$set(_vm.bulkData[data.index], "languages", $$v);
            },
            expression: "bulkData[data.index].languages"
          }
        })];
      }
    }, {
      key: "cell(countries)",
      fn: function (data) {
        return [_c('multiselect', {
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "Enter Countries",
            "open-direction": "bottom",
            "label": "name",
            "track-by": "name",
            "custom-label": _vm.nameWithISO,
            "options": _vm.countriesSearchOptions,
            "searchable": true,
            "close-on-select": true,
            "multiple": true
          },
          model: {
            value: _vm.bulkData[data.index].countries,
            callback: function ($$v) {
              _vm.$set(_vm.bulkData[data.index], "countries", $$v);
            },
            expression: "bulkData[data.index].countries"
          }
        })];
      }
    }, {
      key: "cell(categories)",
      fn: function (data) {
        return [_c('multiselect', {
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "label": "name",
            "track-by": "name",
            "placeholder": "Enter Categories",
            "open-direction": "bottom",
            "options": _vm.categoriesSearchOptions,
            "loading": _vm.isCategoriesSearch,
            "searchable": true,
            "close-on-select": true,
            "multiple": true
          },
          on: {
            "search-change": function ($event) {
              return _vm.categoriesFind($event, _vm.bulkData[data.index]);
            }
          },
          model: {
            value: _vm.bulkData[data.index].categories,
            callback: function ($$v) {
              _vm.$set(_vm.bulkData[data.index], "categories", $$v);
            },
            expression: "bulkData[data.index].categories"
          }
        })];
      }
    }, {
      key: "cell(content_type)",
      fn: function (data) {
        return [_c('b-form-select', {
          staticStyle: {
            "width": "100px"
          },
          attrs: {
            "options": _vm.contentTypeOptions
          },
          model: {
            value: _vm.bulkData[data.index].content_type,
            callback: function ($$v) {
              _vm.$set(_vm.bulkData[data.index], "content_type", $$v);
            },
            expression: "bulkData[data.index].content_type"
          }
        })];
      }
    }, {
      key: "cell(item_type)",
      fn: function (data) {
        return [_c('b-form-select', {
          staticStyle: {
            "width": "100px"
          },
          attrs: {
            "options": _vm.itemTypeOptions
          },
          model: {
            value: _vm.bulkData[data.index].item_type,
            callback: function ($$v) {
              _vm.$set(_vm.bulkData[data.index], "item_type", $$v);
            },
            expression: "bulkData[data.index].item_type"
          }
        })];
      }
    }, {
      key: "cell(release_date)",
      fn: function (data) {
        return [_c('b-form-datepicker', {
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "today-button": ""
          },
          model: {
            value: _vm.bulkData[data.index].release_date,
            callback: function ($$v) {
              _vm.$set(_vm.bulkData[data.index], "release_date", $$v);
            },
            expression: "bulkData[data.index].release_date"
          }
        })];
      }
    }, {
      key: "cell(description)",
      fn: function (data) {
        return [_c('b-form-textarea', {
          staticStyle: {
            "width": "300px"
          },
          model: {
            value: _vm.bulkData[data.index].description,
            callback: function ($$v) {
              _vm.$set(_vm.bulkData[data.index], "description", $$v);
            },
            expression: "bulkData[data.index].description"
          }
        })];
      }
    }, {
      key: "cell(isbn)",
      fn: function (data) {
        return [_c('b-form-input', {
          staticStyle: {
            "width": "200px"
          },
          model: {
            value: _vm.bulkData[data.index].isbn,
            callback: function ($$v) {
              _vm.$set(_vm.bulkData[data.index], "isbn", $$v);
            },
            expression: "bulkData[data.index].isbn"
          }
        })];
      }
    }, {
      key: "cell(ios_tier)",
      fn: function (data) {
        return [_c('multiselect', {
          staticStyle: {
            "min-width": "250px"
          },
          attrs: {
            "label": "tier_code",
            "track-by": "tier_code",
            "placeholder": "Ios Tier",
            "open-direction": "bottom",
            "options": _vm.iosTierSearchOptions,
            "searchable": true,
            "loading": _vm.isIosTierSearch,
            "close-on-select": true,
            "multiple": false
          },
          on: {
            "search-change": _vm.iosTierFind
          },
          model: {
            value: _vm.bulkData[data.index].ios_tier,
            callback: function ($$v) {
              _vm.$set(_vm.bulkData[data.index], "ios_tier", $$v);
            },
            expression: "bulkData[data.index].ios_tier"
          }
        }), _c('em', [_vm._v(" " + _vm._s(_vm._f("formatIDR")(_vm.bulkData[data.index].ios_tier ? _vm.bulkData[data.index].ios_tier.price_idr : 0)) + " ")])];
      }
    }, {
      key: "cell(android_tier)",
      fn: function (data) {
        return [_c('multiselect', {
          staticStyle: {
            "min-width": "250px"
          },
          attrs: {
            "label": "tier_code",
            "track-by": "tier_code",
            "placeholder": "Android Tier",
            "open-direction": "bottom",
            "options": _vm.androidTierSearchOptions,
            "searchable": true,
            "loading": _vm.isAndroidTierSearch,
            "close-on-select": true,
            "multiple": false
          },
          on: {
            "search-change": _vm.androidTierFind
          },
          model: {
            value: _vm.bulkData[data.index].android_tier,
            callback: function ($$v) {
              _vm.$set(_vm.bulkData[data.index], "android_tier", $$v);
            },
            expression: "bulkData[data.index].android_tier"
          }
        }), _vm._v(" " + _vm._s(_vm._f("formatIDR")(_vm.bulkData[data.index].android_tier ? _vm.bulkData[data.index].android_tier.price_idr : 0)) + " ")];
      }
    }, {
      key: "cell(printed_currency)",
      fn: function (data) {
        return [_c('b-form-select', {
          staticStyle: {
            "width": "100px"
          },
          attrs: {
            "options": _vm.currencyOptions
          },
          model: {
            value: _vm.bulkData[data.index].printed_currency,
            callback: function ($$v) {
              _vm.$set(_vm.bulkData[data.index], "printed_currency", $$v);
            },
            expression: "bulkData[data.index].printed_currency"
          }
        })];
      }
    }, {
      key: "cell(printed_price)",
      fn: function (data) {
        return [_c('b-form-input', {
          staticStyle: {
            "width": "100px"
          },
          attrs: {
            "type": "number",
            "step": "any"
          },
          model: {
            value: _vm.bulkData[data.index].printed_price,
            callback: function ($$v) {
              _vm.$set(_vm.bulkData[data.index], "printed_price", $$v);
            },
            expression: "bulkData[data.index].printed_price"
          }
        })];
      }
    }, {
      key: "cell(offers_premium)",
      fn: function (data) {
        return [_c('multiselect', {
          staticStyle: {
            "min-width": "250px"
          },
          attrs: {
            "label": "name",
            "track-by": "name",
            "placeholder": "Offers Premium",
            "open-direction": "bottom",
            "options": _vm.offersSearchOptions,
            "searchable": true,
            "loading": _vm.isOffersSearch,
            "close-on-select": true,
            "multiple": true,
            "disabled": true
          },
          model: {
            value: _vm.bulkData[data.index].offers_premium,
            callback: function ($$v) {
              _vm.$set(_vm.bulkData[data.index], "offers_premium", $$v);
            },
            expression: "bulkData[data.index].offers_premium"
          }
        })];
      }
    }])
  })], 1)])], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }